export enum AlertEnum {
  WARNING = "warning",
  DANGER = 'danger'
}
